import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const handleLearnProcess = () => {
    const processSection = document.getElementById('process-overview');
    if (processSection) {
      processSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const pillars = [
    {
      icon: 'ri-bug-line',
      label: 'BSF Farming & Protein',
      desc: 'Sustainable insect protein, organic fertilizer & training',
      color: 'bg-green-600',
      action: () => navigate('/products'),
      cta: 'Explore BSF Products',
    },
    {
      icon: 'ri-leaf-line',
      label: 'Pure Moringa Powder',
      desc: 'Locally grown superfood — vitamins, minerals & antioxidants',
      color: 'bg-amber-500',
      action: () => window.open('https://paystack.shop/pay/v9-4hu3n50', '_blank'),
      cta: 'Order Moringa',
    },
  ];

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">

      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/edited_aec9c6a244aec2645af1bb46c7cb4c49_fa7c1d5f.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 w-full flex flex-col items-center">

        {/* Badge row */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
          <span className="inline-flex items-center bg-green-600/80 backdrop-blur-sm text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest">
            <i className="ri-bug-line mr-2"></i>BSF Farming
          </span>
          <span className="w-1 h-1 rounded-full bg-white/50"></span>
          <span className="inline-flex items-center bg-amber-500/80 backdrop-blur-sm text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest">
            <i className="ri-leaf-line mr-2"></i>Pure Moringa Powder
          </span>
          <span className="w-1 h-1 rounded-full bg-white/50"></span>
          <span className="inline-flex items-center bg-white/20 backdrop-blur-sm text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest">
            <i className="ri-map-pin-line mr-2"></i>Proudly Ghanaian
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight text-center max-w-5xl">
          Nature's Best,<br />
          <span className="text-green-300">Ghana's Own</span>
        </h1>

        {/* Sub-headline */}
        <p className="text-xl md:text-2xl text-green-50 mb-12 max-w-4xl mx-auto leading-relaxed text-center font-medium">
          From Black Soldier Fly protein and organic fertilizers to pure moringa powder superfoods — MY AVA Farms is Ghana's home of sustainable, natural agriculture built for community, health and the planet.
        </p>

        {/* Primary CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
          <button
            onClick={() => navigate('/products')}
            className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-store-2-line mr-2"></i>Shop All Products
          </button>
          <a
            href="https://paystack.shop/pay/v9-4hu3n50"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line mr-2"></i>Order Moringa Powder
          </a>
          <button
            onClick={handleLearnProcess}
            className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap border border-white/30"
          >
            Learn Our Process
          </button>
        </div>

        {/* Two pillar cards at bottom */}
        <div className="grid sm:grid-cols-2 gap-4 w-full max-w-3xl mt-10">
          {pillars.map((p, i) => (
            <div
              key={i}
              className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 flex flex-col gap-3 hover:bg-white/20 transition-all"
            >
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${p.color} shrink-0`}>
                  <i className={`${p.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm">{p.label}</p>
                  <p className="text-green-100 text-xs leading-snug">{p.desc}</p>
                </div>
              </div>
              <button
                onClick={p.action}
                className="w-full text-center text-xs font-semibold text-white border border-white/30 hover:bg-white/20 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                {p.cta} <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce z-10">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
